<template>
  <div class='notice'>
		<div v-for="(item,index) in notice" :key="index" class="notice-item">{{item}}</div>
		<div class="foot">
			<div v-for="(item,index) in foot" :key="index" class="foot-item">{{item}}</div>
		</div>
	</div>
</template>

<script>
export default {
    props:['list'],
    data() {
        return {
            notice:[],
            foot:[],
        
        }
    },
    created() {
        this.notice=this.list.bottomMessage
        this.foot=this.list.supplier	
    },
    methods: {
        
    }
}
</script>

<style lang='scss' scoped>
    .notice {
		width: 94vw;
		position: relative;
		left: 50%;
		margin-left: -47vw;
		margin-top: 30px;
		font-size:12px;
		font-family:PingFang SC;
		color:#666;
		line-height: 22px;
		text-align: left;
		.foot {
			margin: 25px 0;
			width: 100%;
			.foot-item {
				width: 100%;
				text-align: center;
				font-size:11px;
				font-family:PingFang SC;
				color:#333;
				font-weight: bold;
			}
		}
	}
</style>